window.appProducts = window.appProducts || (function () {

  const S_PRODUCTS = '#products'
  const D = document
  const W = window

  function update(html){
    if(!html){
      return false
    }
    let element = D.createElement('div');
    element.insertAdjacentHTML('beforeend', html)
    let containerNew = element.querySelector(S_PRODUCTS)
    if(!containerNew){
      return false
    }
    let containerOld = D.querySelector(S_PRODUCTS)
    if(!containerOld){
      return false
    }
    if(containerOld.replaceWith){
      containerOld.replaceWith(containerNew)
    } else {
      // ie11
      containerOld.innerHTML = containerNew.innerHTML
    }
    if(W.appProduct){
      W.appProduct.update()
    }
  }

  return {
    update
  }
})()
